import { render } from "./PageKullanicilar.vue?vue&type=template&id=33420ab8"
import script from "./PageKullanicilar.vue?vue&type=script&lang=js"
export * from "./PageKullanicilar.vue?vue&type=script&lang=js"
script.render = render

export default script